import { render } from "./PatientCancellationCarousel.vue?vue&type=template&id=df130856&ts=true"
import script from "./PatientCancellationCarousel.vue?vue&type=script&lang=ts"
export * from "./PatientCancellationCarousel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/PatientDetail/PatientCancellationCarousel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "df130856"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('df130856', __exports__)) {
    api.reload('df130856', __exports__)
  }
  
  module.hot.accept("./PatientCancellationCarousel.vue?vue&type=template&id=df130856&ts=true", () => {
    api.rerender('df130856', render)
  })

}


export default __exports__